import * as React from 'react';
import styled from 'styled-components';
import { useProgressiveImage } from '../utils/hooks/useProgressiveImage';

interface IFadeInBackground {
  url: string;
  height?: string;
  opacity?: number;
  position?: string;
  fixed?: boolean;
  showOnMobile?: boolean;
}

interface IProps {
  url?: string;
  height?: string;
  position?: string;
  fixed?: boolean;
  opacity?: number;
  loaded: boolean;
}

export const FadeInBackground: React.FC<IFadeInBackground> = React.memo(
  ({ url, height, opacity, position, fixed, showOnMobile }) => {
    const { loaded } = useProgressiveImage({
      url,
    });

    return (
      <StyledBackgroundWrapper className={showOnMobile ? 'show-on-mobile' : ''}>
        <StyledBackground
          height={height}
          url={url}
          opacity={opacity}
          position={position}
          fixed={fixed}
          loaded={loaded}
        >
          <StyledBackgroundGradient height={height} loaded={loaded} />
        </StyledBackground>
      </StyledBackgroundWrapper>
    );
  },
  (prevProps, nextProps) => {
    if (prevProps.url === nextProps.url) {
      return true;
    }
    return false;
  }
);

const StyledBackgroundWrapper = styled.div<any>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: -1;
  overflow: hidden;

  img {
    position: relative;
    width: 1px;
    height: 1px;
  }

  @media all and (max-width: 600px) {
    display: none;

    &.show-on-mobile {
      display: flex;
    }
  }
`;

const StyledBackground = styled.div<IProps>`
  transition: opacity 0.3s ease-out;
  width: 100%;
  height: ${(props) => (props.height ? props.height : '100vh')};
  position: absolute;
  top: 0;
  left: 0;
  background: ${(props) => `url(${props.url}) no-repeat`};
  background-size: cover;
  background-position: ${(props) =>
    props.position ? props.position : 'center'};
  z-index: -1;
  opacity: ${(props) =>
    props.loaded ? (props.opacity ? props.opacity : 0.2) : 0};

  ${(props) => (props.fixed ? 'background-attachment: fixed;' : '')}
`;

const StyledBackgroundGradient = styled.div<IProps>`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: ${(props) => (props.height ? props.height : '50vh')};
  background: linear-gradient(transparent, #171719);
  opacity: ${(props) => (props.loaded ? 1 : 0)};
`;
